export default "/images/github_footer_logo.png";